<template>
    <a class="vm-avatar-message flex-box lhi flex-wrap" :href="href" onclick="return false;">
        <avatar class="wh48" :user="dialog.user" :bubble_text="dialog.unread_count > 0 ? dialog.unread_count : ''" :is_no_href="true">
            <div slot="info" class="message-short text-overflow-1 mt8">
                {{dialog.desc}}
            </div>
            <div slot="name-right" class="flex-box flex-align-items-center flex-item-1 ml16 flex-justify-content-space-between">
                <span class="black-5 fwn flex-shrink-0 fsl14" v-text="$time_show(dialog.send_time)"></span>
                <div class="flex-box flex-align-items-center" v-if="browser_size != 'small'">
                    <sponsor-in-out type="out" v-if="out_detail.current_amount > 0" :sponsor="out_detail"></sponsor-in-out>
                    <span v-if="out_detail.current_amount > 0 && in_detail.current_amount > 0" class="ml16 mr16 line-vertical"></span>
                    <sponsor-in-out v-if="in_detail.current_amount > 0"  :sponsor="in_detail"></sponsor-in-out>
                </div>
            </div>
            <div slot="info" class="mt8 flex-box flex-align-items-center" v-if="browser_size == 'small'">
                <sponsor-in-out type="out" v-if="out_detail.current_amount > 0"  :sponsor="out_detail"></sponsor-in-out>
                <span v-if="out_detail.current_amount > 0 && in_detail.current_amount > 0" class="ml16 mr16 line-vertical"></span>
                <sponsor-in-out v-if="in_detail.current_amount > 0"  :sponsor="in_detail"></sponsor-in-out>
            </div>
        </avatar>
    </a>
</template>

<script>
import {mapState} from 'vuex'
export default {
    name: 'avatar-message',
    props: {
        dialog:{
            type:Object,
            default(){
                return {}
            }
        },
        href:{//支持浏览器右键显示新建标签页
            default(){
                return ''
            }
        }
    },
    data() {
        return {
            in_detail:this.dialog.sponsor_info.in_detail,
            out_detail:this.dialog.sponsor_info.out_detail,
        };
    },
    computed:{
        ...mapState('app',[
            'browser_size'
        ])
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style lang="stylus" scoped>
.vm-avatar-message{
    .vm-avatar /deep/{
        width 100%
        .user-name{
            font-size fs2rem(16)
        }
    }
    .message-short{
        color $black-8
        font-size fs2rem(14)
        overflow hidden
    }
    @media (max-width: $width-mobile) {
        .vm-avatar /deep/{
            .avatar-name{
                /*width 48vw*/
                flex 1
            }
        }
    }
}
</style>
